import React from "react";

import { Grid } from "@/components/Grid";
import { IPricing } from "@/containers/Pricing";
import { PricingProvider } from "@/containers/Pricing/state/context";
import { PricingSlider } from "@/containers/PricingSlider";

type IProps = IPricing & JSX.IntrinsicElements["div"];

export const PricingSectionFigmaBackup: React.FC<IProps> = props => {
  return (
    <Grid
      customStyle={{
        flexDirection: "column",
      }}
      wrapperStyle={{ position: "relative" }}
      id="PricingSection"
    >
      <PricingProvider>
        <PricingSlider isFigmaBackup {...props} />
      </PricingProvider>
    </Grid>
  );
};
